import { colors } from 'app-v2/design-systems/theme'
import { CircleMinus, CirclePlus } from 'app/assets/icons'
import { Text, fonts } from 'app/common/typography'
import React from 'react'
import { colors as oldColors } from 'shared/assets/styles'
import styled from 'styled-components'

const { grey } = oldColors

type Props = {
    name?: string,
    isMore: boolean,
    onPress: () => void
}

export const MorePersonalized = ({ name, onPress, isMore }: Props) => {
    const Circle = isMore ? CirclePlus : CircleMinus
    return (
        <Widget onClick={onPress}>
            <RowContainer>
                <RowContainerCenter>
                    <TextContainer>
                        {name && <StyledText>{name}</StyledText>}
                    </TextContainer>
                </RowContainerCenter>
                <RowContainerCenter>
                    <Circle
                        background={colors.crunchyGreen}
                        color={colors.lightMayo}
                    />
                </RowContainerCenter>
            </RowContainer>
        </Widget>
    )
}

const Widget = styled.div`
    border-radius: 8px;
    border: 1px dashed ${grey};
    margin: 5px;
    cursor: pointer;
`

const RowContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 15px;
`

const RowContainerCenter = styled.div`
    flex-direction: row;
    align-items: center;
`

const TextContainer = styled.div``

const StyledText = styled(Text)`
    font-family: ${fonts.roboto};
    font-size: 16px;
    margin-left: 30px;
`
